<div fxLayout="column" class="container" fxLayoutAlign="center center">
    <div class="text">
        <p>
            Bienvenue sur le site de la
        </p>
        <p>
            Coupe De France Legacy !
        </p>
    </div>
    <div class="newUpdate">
        Changement pour 2026 :<br> Les opens qualifient un joueur de plus tous les 14 joueurs !
    </div>
    <div class="logoDiv">
        <picture>
            <source [srcset]="logoWebp" type="image/webp">
            <img [src]="logo" class="logo" alt="logo">
        </picture>
    </div>
    <div class="join-us">
        Join us on Discord
    </div>
    <div class="discordDiv">
        <picture>
            <source [srcset]="discordLogoWebp" type="image/webp">
            <img [src]="discordLogo" class="logo" alt="Logo discord" (click)="goDiscord()">
        </picture>
    </div>
</div>